// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__aapv+","faq__title":"Faq_faq__title__ote-b","faq__wrapper":"Faq_faq__wrapper__G3pBu","faq__left":"Faq_faq__left__jcfF1","faq__right":"Faq_faq__right__8gf8+"};